import { memo } from 'react';

import { Skeleton } from '@doger/ui/components/ui/skeleton';

import styles from './metrics-skeleton.module.scss';

const MetricsSkeleton = memo(() => (
  <div className={styles.container}>
    <div className={styles.header}>
      <Skeleton className={styles.titleSkeleton} />
      <div className={styles.headerInfo}>
        <Skeleton className={styles.uptimeSkeleton} />
        <LastUpdatedSkeleton />
      </div>
    </div>

    <div className={styles.healthStatusSkeleton}>
      <Skeleton className={styles.healthIndicatorSkeleton} />
    </div>

    <div className={styles.metricsGrid}>
      <div className={styles.metricsSection}>
        <Skeleton className={styles.sectionTitleSkeleton} />
        <div className={styles.cardsGrid}>
          <MetricCardSkeleton />
          <MetricCardSkeleton />
          <MetricCardSkeleton />
        </div>
      </div>

      <div className={styles.metricsSection}>
        <Skeleton className={styles.sectionTitleSkeleton} />
        <div className={styles.cardsGrid}>
          <MetricCardSkeleton />
          <MetricCardSkeleton />
          <MetricCardSkeleton />
          <MetricCardSkeleton />
        </div>
      </div>

      <div className={styles.metricsSection}>
        <Skeleton className={styles.sectionTitleSkeleton} />
        <div className={styles.cardsGrid}>
          <MetricCardSkeleton />
          <MetricCardSkeleton />
          <MetricCardSkeleton />
          <MetricCardSkeleton />
        </div>
      </div>

      <div className={styles.metricsSection}>
        <Skeleton className={styles.sectionTitleSkeleton} />
        <div className={styles.cardsGrid}>
          <MetricCardSkeleton />
          <MetricCardSkeleton />
          <MetricCardSkeleton />
          <MetricCardSkeleton />
        </div>
      </div>
    </div>
  </div>
));

const MetricCardSkeleton = memo(() => (
  <div className={styles.cardSkeleton}>
    <div className={styles.cardHeader}>
      <Skeleton className={styles.cardTitleSkeleton} />
      <Skeleton className={styles.statusIndicatorSkeleton} />
    </div>
    <Skeleton className={styles.cardValueSkeleton} />
    <Skeleton className={styles.cardDescriptionSkeleton} />
  </div>
));

MetricsSkeleton.displayName = 'MetricsSkeleton';
MetricCardSkeleton.displayName = 'MetricCardSkeleton';

export const LastUpdatedSkeleton = memo(() => (
  <Skeleton className={styles.lastUpdatedSkeleton} />
));

export { MetricsSkeleton };
